/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// GET /api/billing-events/health/postgres-event-processing
// ts-unused-exports:disable-next-line
export const getBillingEventsHealthStatus = async () =>
  fetchAsJson<{
    status: 'healthy' | 'unhealthy'
    threshold: number
    unprocessed_events_count: number
  }>('/api/billing-events/health/postgres-event-processing', {
    method: 'GET',
  })

// PATCH /api/v1/admin/billing/organization/{organization_id}/trial
// ts-unused-exports:disable-next-line
export const extendTrialAdminV1 = async (args: {
  pathParameters: operations['ExtendTrialAdminV1']['parameters']['path']
  queryParameters?: operations['ExtendTrialAdminV1']['parameters']['query']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/billing/organization/{organization_id}/trial', args),
    {
      method: 'PATCH',
    },
  )

// PUT /api/v1/admin/marketplace/azure/{organization_id}/enable_conversion
// ts-unused-exports:disable-next-line
export const enableAzureConversionV1 = async (args: {
  pathParameters: operations['enableAzureConversionV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/marketplace/azure/{organization_id}/enable_conversion', args),
    {
      method: 'PUT',
    },
  )

// POST /api/v1/billing/budgets/run_costs_alerting_service
// ts-unused-exports:disable-next-line
export const runCostsAlertingV1 = async () =>
  fetchAsJson<{
    job_id: string
    message: string
  }>('/api/v1/billing/budgets/run_costs_alerting_service', {
    method: 'POST',
  })

// POST /api/v1/billing/ecu_prices
// ts-unused-exports:disable-next-line
export const createEcuPricesV1 = async <
  T = operations['createEcuPricesV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createEcuPricesV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createEcuPricesV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createEcuPricesV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v1/billing/ecu_prices', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/billing/invoices/
// ts-unused-exports:disable-next-line
export const getInvoicesV1 = async (args?: {
  queryParameters?: operations['getInvoicesV1']['parameters']['query']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/invoices/', args), {
    method: 'GET',
  })

// POST /api/v1/billing/invoices/publish
// ts-unused-exports:disable-next-line
export const updateBillingPublishInvoicesV1 = async <
  T = operations['updateBillingPublishInvoicesV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingPublishInvoicesV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['updateBillingPublishInvoicesV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingPublishInvoicesV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<{
    published_count: number
    success: boolean
  }>('/api/v1/billing/invoices/publish', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/billing/jobs/{id}
// ts-unused-exports:disable-next-line
export const getBillingJobDetailsV1 = async (args: {
  pathParameters: operations['getBillingJobDetailsV1']['parameters']['path']
}) =>
  fetchAsJson<{
    job: {
      ended: string
      name: string
      started: string
    }
  }>(applyParameters('/api/v1/billing/jobs/{id}', args), {
    method: 'GET',
  })

// POST /api/v1/billing/line_item
// ts-unused-exports:disable-next-line
export const createLineItemV1 = async <
  T = operations['createLineItemV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createLineItemV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  queryParameters?: operations['createLineItemV1']['parameters']['query']
  body: Exact<
    T,
    operations['createLineItemV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createLineItemV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/line_item', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/line_item/cancel
// ts-unused-exports:disable-next-line
export const cancelLineItemsV1 = async <
  T = operations['cancelLineItemsV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['cancelLineItemsV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['cancelLineItemsV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['cancelLineItemsV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<{
    line_items: unknown
    success: boolean
  }>('/api/v1/billing/line_item/cancel', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/line_item/check
// ts-unused-exports:disable-next-line
export const checkLineItemV1 = async <
  T = operations['checkLineItemV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['checkLineItemV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['checkLineItemV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['checkLineItemV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v1/billing/line_item/check', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/line_item/extend
// ts-unused-exports:disable-next-line
export const extendLineItemsV1 = async <
  T = operations['extendLineItemsV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['extendLineItemsV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['extendLineItemsV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['extendLineItemsV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v1/billing/line_item/extend', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/metering
// ts-unused-exports:disable-next-line
export const startBillingMeteringV1 = async () =>
  fetchAsJson<{
    job: {
      id: string
    }
  }>('/api/v1/billing/metering', {
    method: 'POST',
  })

// POST /api/v1/billing/organization/{organization_ids}/used_csps
// ts-unused-exports:disable-next-line
export const getOrganizationUsedCspsV1 = async (args: {
  pathParameters: operations['getOrganizationUsedCspsV1']['parameters']['path']
}) =>
  fetchAsJson<unknown>(
    applyParameters('/api/v1/billing/organization/{organization_ids}/used_csps', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/billing/organization/{organization_id}
// ts-unused-exports:disable-next-line
export const getBillingDetailsV1 = async (args: {
  pathParameters: operations['getBillingDetailsV1']['parameters']['path']
}) =>
  fetchAsJson<{
    billing_model:
      | 'on_demand'
      | 'monthly'
      | 'annual'
      | 'annual_overages'
      | 'drawdown'
      | 'prepaid_consumption'
      | 'trial'
      | 'none'
    billing_processing:
      | 'biller_v1'
      | 'manual'
      | 'gcp_tracker'
      | 'heroku_tracker'
      | 'consumption'
      | 'metering'
    billing_status:
      | 'good_standing'
      | 'balance_due'
      | 'pending_suspension'
      | 'suspended'
      | 'terminated'
      | 'unsubscribed'
    channel: 'direct' | 'aws' | 'azure' | 'gcp' | 'heroku'
    level: string
    marketplace_integration: {
      codename: string
      provider: 'found' | 'aws' | 'azure' | 'gcp' | 'heroku'
      version: number
    }
    partner_selling: 'reseller' | 'direct'
    payment_method: 'purchase_order' | 'credit_card' | 'third_party_billing'
    reported_successfully_at: string
    trial_state:
      | 'in_trial'
      | 'in_trial_extended'
      | 'converted_pending_first_bill'
      | 'converted'
      | 'expired'
      | 'eligible'
      | 'ineligible'
    unsubscribed_at: string
  }>(applyParameters('/api/v1/billing/organization/{organization_id}', args), {
    method: 'GET',
  })

// PATCH /api/v1/billing/organization/{organization_id}
// ts-unused-exports:disable-next-line
export const orgDomainChangeV1 = async <
  T = operations['orgDomainChangeV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['orgDomainChangeV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['orgDomainChangeV1']['parameters']['path']
  body: Exact<
    T,
    operations['orgDomainChangeV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['orgDomainChangeV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/organization/{organization_id}', args), {
    method: 'PATCH',
    body: JSON.stringify(args.body),
  })

// PUT /api/v1/billing/organization/{organization_id}/activate
// ts-unused-exports:disable-next-line
export const activateBillingOrganizationV1 = async <
  T = operations['activateBillingOrganizationV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['activateBillingOrganizationV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['activateBillingOrganizationV1']['parameters']['path']
  body: Exact<
    T,
    operations['activateBillingOrganizationV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['activateBillingOrganizationV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/activate', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/budget
// ts-unused-exports:disable-next-line
export const createBudgetV1 = async <
  T = operations['createBudgetV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createBudgetV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['createBudgetV1']['parameters']['path']
  body: Exact<
    T,
    operations['createBudgetV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createBudgetV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<{
    id: number
  }>(applyParameters('/api/v1/billing/organization/{organization_id}/budget', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/organization/{organization_id}/budget/{budget_id}
// ts-unused-exports:disable-next-line
export const updateBudgetV1 = async <
  T = operations['updateBudgetV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBudgetV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBudgetV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBudgetV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBudgetV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/budget/{budget_id}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/billing/organization/{organization_id}/budgets
// ts-unused-exports:disable-next-line
export const listBudgetsV1 = async (args: {
  pathParameters: operations['listBudgetsV1']['parameters']['path']
}) =>
  fetchAsJson<Array<components['schemas']['Budget']>>(
    applyParameters('/api/v1/billing/organization/{organization_id}/budgets', args),
    {
      method: 'GET',
    },
  )

// DELETE /api/v1/billing/organization/{organization_id}/budgets/{budget_id}
// ts-unused-exports:disable-next-line
export const deleteBudgetV1 = async (args: {
  pathParameters: operations['deleteBudgetV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/budgets/{budget_id}', args),
    {
      method: 'DELETE',
    },
  )

// GET /api/v1/billing/organization/{organization_id}/budgets/{budget_id}
// ts-unused-exports:disable-next-line
export const getBudgetV1 = async (args: {
  pathParameters: operations['getBudgetV1']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Budget']>(
    applyParameters('/api/v1/billing/organization/{organization_id}/budgets/{budget_id}', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/billing/organization/{organization_id}/charge
// ts-unused-exports:disable-next-line
export const chargeOrganizationV1 = async <
  T = operations['chargeOrganizationV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['chargeOrganizationV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['chargeOrganizationV1']['parameters']['path']
  queryParameters?: operations['chargeOrganizationV1']['parameters']['query']
  body: Exact<
    T,
    operations['chargeOrganizationV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['chargeOrganizationV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/charge', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/check
// ts-unused-exports:disable-next-line
export const checkOrganizationLineItemV1 = async <
  T = operations['checkOrganizationLineItemV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['checkOrganizationLineItemV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['checkOrganizationLineItemV1']['parameters']['path']
  body: Exact<
    T,
    operations['checkOrganizationLineItemV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['checkOrganizationLineItemV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/organization/{organization_id}/check', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/billing/organization/{organization_id}/cloud_resources
// ts-unused-exports:disable-next-line
export const getBillingCloudResourcesV1 = async (args: {
  pathParameters: operations['getBillingCloudResourcesV1']['parameters']['path']
}) =>
  fetchAsJson<Array<components['schemas']['CloudResource']>>(
    applyParameters('/api/v1/billing/organization/{organization_id}/cloud_resources', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/billing/organization/{organization_id}/credit
// ts-unused-exports:disable-next-line
export const creditOrganizationV1 = async <
  T = operations['creditOrganizationV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['creditOrganizationV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['creditOrganizationV1']['parameters']['path']
  queryParameters?: operations['creditOrganizationV1']['parameters']['query']
  body: Exact<
    T,
    operations['creditOrganizationV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['creditOrganizationV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/credit', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/billing/organization/{organization_id}/deactivate
// ts-unused-exports:disable-next-line
export const deactivateBillingOrganizationV1 = async <
  T = operations['deactivateBillingOrganizationV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['deactivateBillingOrganizationV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['deactivateBillingOrganizationV1']['parameters']['path']
  body: Exact<
    T,
    operations['deactivateBillingOrganizationV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['deactivateBillingOrganizationV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/deactivate', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/billing/organization/{organization_id}/entitlements
// ts-unused-exports:disable-next-line
export const getEntitlementsV1 = async (args: {
  pathParameters: operations['getEntitlementsV1']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Entitlement']>(
    applyParameters('/api/v1/billing/organization/{organization_id}/entitlements', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/billing/organization/{organization_id}/history
// ts-unused-exports:disable-next-line
export const getHistoryV1 = async (args: {
  pathParameters: operations['getHistoryV1']['parameters']['path']
}) =>
  fetchAsJson<{
    invoices: Array<{
      external_invoice_pdf_download: string
      invoice_pdf_download: string
      invoiced_amount_in_cents: number
      issue_date: string
      number: number
      organization_id: string
      payment_metadata: {
        amount: number
        currency: string
        external_invoice_id: string
      }
      period_end_date: string
      period_start_date: string
      status: string
      type: string
    }>
    statements: Array<{
      currency: string
      ecu_total: number
      invoiced_amount_in_cents: number
      issue_date: string
      number: string
      organization_id: string
      period_end_date: string
      period_start_date: string
      status: string
      type: string
      usage_pdf_download: string
    }>
  }>(applyParameters('/api/v1/billing/organization/{organization_id}/history', args), {
    method: 'GET',
  })

// GET /api/v1/billing/organization/{organization_id}/history/{statement_number}
// ts-unused-exports:disable-next-line
export const getHistoryByStatementV1 = async (args: {
  pathParameters: operations['getHistoryByStatementV1']['parameters']['path']
}) =>
  fetchAsJson<{
    invoices: Array<{
      external_invoice_pdf_download: string
      invoice_pdf_download: string
      invoiced_amount_in_cents: number
      issue_date: string
      number: number
      organization_id: string
      payment_metadata: {
        amount: number
        currency: string
        external_invoice_id: string
      }
      period_end_date: string
      period_start_date: string
      status: string
      type: string
    }>
    statements: Array<{
      currency: string
      ecu_total: number
      invoiced_amount_in_cents: number
      issue_date: string
      number: string
      organization_id: string
      period_end_date: string
      period_start_date: string
      status: string
      type: string
      usage_pdf_download: string
    }>
  }>(
    applyParameters(
      '/api/v1/billing/organization/{organization_id}/history/{statement_number}',
      args,
    ),
    {
      method: 'GET',
    },
  )

// POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}
// ts-unused-exports:disable-next-line
export const updateBillingOrganizationSettingsV1 = async <
  T = operations['updateBillingOrganizationSettingsV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingOrganizationSettingsV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBillingOrganizationSettingsV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBillingOrganizationSettingsV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingOrganizationSettingsV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/invoice/{invoice_id}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/event
// ts-unused-exports:disable-next-line
export const updateBillingOrganizationInvoiceEventV1 = async <
  T = operations['updateBillingOrganizationInvoiceEventV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingOrganizationInvoiceEventV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBillingOrganizationInvoiceEventV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBillingOrganizationInvoiceEventV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingOrganizationInvoiceEventV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/event',
      args,
    ),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/payment_status
// ts-unused-exports:disable-next-line
export const updateBillingOrganizationPaymentStatusV1 = async <
  T = operations['updateBillingOrganizationPaymentStatusV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingOrganizationPaymentStatusV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBillingOrganizationPaymentStatusV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBillingOrganizationPaymentStatusV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingOrganizationPaymentStatusV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/payment_status',
      args,
    ),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/regenerate_external_invoice
// ts-unused-exports:disable-next-line
export const regenerateExternalInvoiceV1 = async (args: {
  pathParameters: operations['regenerateExternalInvoiceV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/billing/organization/{organization_id}/invoice/{invoice_id}/regenerate_external_invoice',
      args,
    ),
    {
      method: 'POST',
    },
  )

// GET /api/v1/billing/organization/{organization_id}/line_items
// ts-unused-exports:disable-next-line
export const getLineItemsV1 = async (args: {
  pathParameters: operations['getLineItemsV1']['parameters']['path']
  queryParameters?: operations['getLineItemsV1']['parameters']['query']
}) =>
  fetchAsJson<
    Array<{
      activated_at: string
      activation_code: string
      active: boolean
      cancel_id: string
      channel: string
      currency: string
      discount: number
      ecu_balance: number
      ecu_prepaid_charge: number
      ecu_price: number
      ecu_quantity: number
      end: string
      end_type: 'time' | 'depletion'
      external_payment_account: {
        aws: {
          account_id: string
          customer_id: string
          product_code: string
          sku: string
        }
        azure: {
          plan_id: string
          subscription_id: string
        }
        gcp: {
          entitlement_id: string
          plan: string
          quote_id: string
          state:
            | 'ENTITLEMENT_STATE_UNSPECIFIED'
            | 'ENTITLEMENT_ACTIVATION_REQUESTED'
            | 'ENTITLEMENT_ACTIVE'
            | 'ENTITLEMENT_PENDING_CANCELLATION'
            | 'ENTITLEMENT_CANCELLED'
            | 'ENTITLEMENT_PENDING_PLAN_CHANGE'
            | 'ENTITLEMENT_PENDING_PLAN_CHANGE_APPROVAL'
            | 'ENTITLEMENT_SUSPENDED'
        }
      }
      external_reseller_id: string
      id: string
      metadata: unknown
      organization_id: string
      prepaid_charge_after: string
      purchased_balance: number
      reason: string
      start: string
      type: string
    }>
  >(applyParameters('/api/v1/billing/organization/{organization_id}/line_items', args), {
    method: 'GET',
  })

// PATCH /api/v1/billing/organization/{organization_id}/line_items/activate/{activation_code}
// ts-unused-exports:disable-next-line
export const activateLineItemsV1 = async <
  T = operations['activateLineItemsV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['activateLineItemsV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['activateLineItemsV1']['parameters']['path']
  body: Exact<
    T,
    operations['activateLineItemsV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['activateLineItemsV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/billing/organization/{organization_id}/line_items/activate/{activation_code}',
      args,
    ),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/billing/organization/{organization_id}/paid_in_full
// ts-unused-exports:disable-next-line
export const validateOrgPaidInFull = async (args: {
  pathParameters: operations['validateOrgPaidInFull']['parameters']['path']
}) =>
  fetchAsJson<{
    error: {
      id: string
      message: string
    }
    success: boolean
  }>(applyParameters('/api/v1/billing/organization/{organization_id}/paid_in_full', args), {
    method: 'GET',
  })

// GET /api/v1/billing/organization/{organization_id}/payment_details
// ts-unused-exports:disable-next-line
export const getPaymentDetailsV1 = async (args: {
  pathParameters: operations['getPaymentDetailsV1']['parameters']['path']
}) =>
  fetchAsJson<{
    data: unknown
    external_billing_info: unknown
    recurly_billing_info: unknown
  }>(applyParameters('/api/v1/billing/organization/{organization_id}/payment_details', args), {
    method: 'GET',
  })

// GET /api/v1/billing/organization/{organization_id}/prepaids
// ts-unused-exports:disable-next-line
export const getBillingPrepaidsV1 = async (args: {
  pathParameters: operations['getBillingPrepaidsV1']['parameters']['path']
  queryParameters?: operations['getBillingPrepaidsV1']['parameters']['query']
}) =>
  fetchAsJson<{
    premium_products: Array<{
      data: unknown
      end: string
      identifier: string
      premium_product_id: number
      price: number
      product_id: number
      start: string
    }>
    subscriptions: Array<{
      created: string
      data: unknown
      last_modified: string
      subscription_id: string
      subscription_range: {
        end: string
        start: string
      }
      subscription_type: string
    }>
  }>(applyParameters('/api/v1/billing/organization/{organization_id}/prepaids', args), {
    method: 'GET',
  })

// PUT /api/v1/billing/organization/{organization_id}/set_payment_method
// ts-unused-exports:disable-next-line
export const updateBillingPaymentMethodV1 = async <
  T = operations['updateBillingPaymentMethodV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingPaymentMethodV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBillingPaymentMethodV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBillingPaymentMethodV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingPaymentMethodV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/set_payment_method', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/organization/{organization_id}/set_to_direct
// ts-unused-exports:disable-next-line
export const setOrganizationToDirectV1 = async (args: {
  pathParameters: operations['setOrganizationToDirectV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organization/{organization_id}/set_to_direct', args),
    {
      method: 'POST',
    },
  )

// PATCH /api/v1/billing/organization/{organization_id}/trial
// ts-unused-exports:disable-next-line
export const extendTrialV1 = async (args: {
  pathParameters: operations['ExtendTrialV1']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/organization/{organization_id}/trial', args), {
    method: 'PATCH',
  })

// POST /api/v1/billing/organization/{organization_id}/trial
// ts-unused-exports:disable-next-line
export const createTrialV1 = async (args: {
  pathParameters: operations['createTrialV1']['parameters']['path']
  queryParameters?: operations['createTrialV1']['parameters']['query']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/organization/{organization_id}/trial', args), {
    method: 'POST',
  })

// POST /api/v1/billing/organizations/{organization_id}/scrub
// ts-unused-exports:disable-next-line
export const scrubAccount = async (args: {
  pathParameters: operations['scrubAccount']['parameters']['path']
  queryParameters?: operations['scrubAccount']['parameters']['query']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organizations/{organization_id}/scrub', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/billing/organizations/{organization_id}/subscription_level
// ts-unused-exports:disable-next-line
export const requestSubscriptionLevelUpdateV1 = async <
  T = operations['requestSubscriptionLevelUpdateV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['requestSubscriptionLevelUpdateV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['requestSubscriptionLevelUpdateV1']['parameters']['path']
  queryParameters?: operations['requestSubscriptionLevelUpdateV1']['parameters']['query']
  body: Exact<
    T,
    operations['requestSubscriptionLevelUpdateV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['requestSubscriptionLevelUpdateV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/organizations/{organization_id}/subscription_level', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/billing/organizations/{organization_id}/update_account
// ts-unused-exports:disable-next-line
export const updateBillingAccountV1 = async <
  T = operations['updateBillingAccountV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateBillingAccountV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateBillingAccountV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateBillingAccountV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateBillingAccountV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['Account']>(
    applyParameters('/api/v1/billing/organizations/{organization_id}/update_account', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/recurly/organization/{organization_id}/billing_info
// ts-unused-exports:disable-next-line
export const updateRecurlyBillingInfoV1 = async <
  T = operations['updateRecurlyBillingInfoV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['updateRecurlyBillingInfoV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['updateRecurlyBillingInfoV1']['parameters']['path']
  body: Exact<
    T,
    operations['updateRecurlyBillingInfoV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['updateRecurlyBillingInfoV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/recurly/organization/{organization_id}/billing_info', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/billing/statements
// ts-unused-exports:disable-next-line
export const getBillingStatementsV1 = async (args?: {
  queryParameters?: operations['getBillingStatementsV1']['parameters']['query']
}) =>
  fetchAsJson<{
    statements: Array<{
      bill_date: string
      channel: string
      charges: unknown[]
      credits: unknown[]
      currency: string
      end: string
      forfeited: components['schemas']['StatementECUCostDetail']
      internal: boolean
      line_item_balances: {
        current: {
          ecu: number
          money_value: number
          money_value_usd: number
        }
        starting: {
          ecu: number
          money_value: number
          money_value_usd: number
        }
      }
      line_items: unknown[]
      locale: string
      metadata: unknown
      organization_id: string
      organization_name: string
      overages: components['schemas']['StatementECUCostDetail']
      previous_line_items: unknown[]
      reseller: boolean
      revenue: components['schemas']['StatementECUCostDetail']
      sequence_number: number
      serverless_usage_types: unknown[]
      start: string
      statement_id: string
      status: string
      subscription_level: string
      type: string
      usage_types: unknown[]
    }>
  }>(applyParameters('/api/v1/billing/statements', args), {
    method: 'GET',
  })

// POST /api/v1/billing/util/{organization_id}/deprovision
// ts-unused-exports:disable-next-line
export const deprovisionConsumptionOrg = async <
  T = operations['deprovisionConsumptionOrg']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['deprovisionConsumptionOrg']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['deprovisionConsumptionOrg']['parameters']['path']
  body: Exact<
    T,
    operations['deprovisionConsumptionOrg']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['deprovisionConsumptionOrg']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<
    | {
        steps: {
          cancel_line_item: {
            result: string
            status: string
          }
          end_subscription: {
            result: string
            status: string
          }
          recalculate: {
            result: string
            status: string
          }
        }
      }
    | {
        steps: {
          cancel_line_item: {
            error: string
            result: string
            status: string
          }
          end_subscription: {
            error: string
            result: string
            status: string
          }
          recalculate: {
            error: string
            result: string
            status: string
          }
        }
      }
  >(applyParameters('/api/v1/billing/util/{organization_id}/deprovision', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/billing/util/{organization_id}/ledger/complete
// ts-unused-exports:disable-next-line
export const createCompleteLedgerDocV1 = async <
  T = operations['createCompleteLedgerDocV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createCompleteLedgerDocV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['createCompleteLedgerDocV1']['parameters']['path']
  body: Exact<
    T,
    operations['createCompleteLedgerDocV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createCompleteLedgerDocV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/util/{organization_id}/ledger/complete', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/billing/util/{organization_id}/recalculate
// ts-unused-exports:disable-next-line
export const recalculateLedgerV1 = async <
  T = operations['recalculateLedgerV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['recalculateLedgerV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['recalculateLedgerV1']['parameters']['path']
  body: Exact<
    T,
    operations['recalculateLedgerV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['recalculateLedgerV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/billing/util/{organization_id}/recalculate', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// PUT /api/v1/billing/util/{report_type}/{report_id}/set_internal
// ts-unused-exports:disable-next-line
export const setReportInternalV1 = async <
  T = operations['setReportInternalV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['setReportInternalV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['setReportInternalV1']['parameters']['path']
  body: Exact<
    T,
    operations['setReportInternalV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['setReportInternalV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/billing/util/{report_type}/{report_id}/set_internal', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/costs
// ts-unused-exports:disable-next-line
export const getCostsV1 = async (args: {
  queryParameters: operations['getCostsV1']['parameters']['query']
}) =>
  fetchAsJson<{
    balance: {
      available: number
      line_items: Array<{
        activated_at: string
        activation_code: string
        active: boolean
        cancel_id: string
        channel: string
        currency: string
        discount: number
        ecu_balance: number
        ecu_prepaid_charge: number
        ecu_price: number
        ecu_quantity: number
        end: string
        external_reseller_id: string
        id: string
        metadata: unknown
        organization_id: string
        purchased_balance: number
        reason: string
        start: string
        type: string
      }>
      remaining: number
    }
    costs: {
      dimensions: Array<{
        cost: number
        type: string
      }>
      total: number
    }
    hourly_rate: number
    trials: number
  }>(applyParameters('/api/v1/costs', args), {
    method: 'GET',
  })

// GET /api/v1/costs/deployments
// ts-unused-exports:disable-next-line
export const getCostsByDeploymentsV1 = async (args: {
  queryParameters: operations['getCostsByDeploymentsV1']['parameters']['query']
}) =>
  fetchAsJson<{
    deployments: Array<{
      costs: {
        dimensions: Array<{
          cost: number
          type: string
        }>
        total: number
      }
      deployment_name: string
      es_cluster_id: string
      hourly_rate: number
      period: {
        end: string
        start: string
      }
    }>
    total_cost: number
  }>(applyParameters('/api/v1/costs/deployments', args), {
    method: 'GET',
  })

// GET /api/v1/costs/deployments/{deployment_id}
// ts-unused-exports:disable-next-line
export const getCostsItemsByDeploymentV1 = async (args: {
  pathParameters: operations['getCostsItemsByDeploymentV1']['parameters']['path']
  queryParameters: operations['getCostsItemsByDeploymentV1']['parameters']['query']
}) =>
  fetchAsJson<{
    costs: {
      dimensions: Array<{
        cost: number
        type: string
      }>
      total: number
    }
    data_transfer_and_storage: Array<{
      cost: number
      name: string
      quantity: {
        formatted_value: string
        value: number
      }
      rate: {
        formatted_value: string
        value: number
      }
      sku: string
      type: string
    }>
    resources: Array<{
      hours: number
      instance_count: number
      kind: string
      name: string
      period: {
        end: string
        start: string
      }
      price: number
      price_per_hour: number
      sku: string
    }>
  }>(applyParameters('/api/v1/costs/deployments/{deployment_id}', args), {
    method: 'GET',
  })

// GET /api/v1/costs/items
// ts-unused-exports:disable-next-line
export const getCostsItemsV1 = async (args: {
  queryParameters: operations['getCostsItemsV1']['parameters']['query']
}) =>
  fetchAsJson<{
    costs: {
      dimensions: Array<{
        cost: number
        type: string
      }>
      total: number
    }
    data_transfer_and_storage: Array<{
      cost: number
      name: string
      quantity: {
        formatted_value: string
        value: number
      }
      rate: {
        formatted_value: string
        value: number
      }
      sku: string
      type: string
    }>
    resources: Array<{
      hours: number
      instance_count: number
      kind: string
      name: string
      period: {
        end: string
        start: string
      }
      price: number
      price_per_hour: number
      sku: string
    }>
  }>(applyParameters('/api/v1/costs/items', args), {
    method: 'GET',
  })

// POST /api/v1/heroku/resources
// ts-unused-exports:disable-next-line
export const createHerokuResourceV1 = async <
  T = operations['createHerokuResourceV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createHerokuResourceV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createHerokuResourceV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createHerokuResourceV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<{
    config: unknown
    id: string
    message: string
  }>('/api/v1/heroku/resources', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// DELETE /api/v1/heroku/resources/{heroku_uuid}
// ts-unused-exports:disable-next-line
export const deleteHerokuResourceV1 = async (args: {
  pathParameters: operations['deleteHerokuResourceV1']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/heroku/resources/{heroku_uuid}', args), {
    method: 'DELETE',
  })

// PUT /api/v1/heroku/resources/{heroku_uuid}
// ts-unused-exports:disable-next-line
export const putHerokuResourceV1 = async <
  T = operations['putHerokuResourceV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['putHerokuResourceV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['putHerokuResourceV1']['parameters']['path']
  body: Exact<
    T,
    operations['putHerokuResourceV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['putHerokuResourceV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/heroku/resources/{heroku_uuid}', args), {
    method: 'PUT',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/heroku/sso/auth
// ts-unused-exports:disable-next-line
export const postHerokuSSOAuthentication = async <
  T = operations['postHerokuSSOAuthentication']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['postHerokuSSOAuthentication']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['postHerokuSSOAuthentication']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['postHerokuSSOAuthentication']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<{
    authenticated: boolean
    mfa_required: boolean
    session_expiration_time: number
    token: string
    user_id: number
  }>('/api/v1/heroku/sso/auth', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/heroku/sso/login
// ts-unused-exports:disable-next-line
export const postHerokuSSOLogin = async <
  T = operations['postHerokuSSOLogin']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['postHerokuSSOLogin']['requestBody'],
        undefined
      >['content']['application/x-www-form-urlencoded'],
>(args: {
  body: Exact<
    T,
    operations['postHerokuSSOLogin']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['postHerokuSSOLogin']['requestBody'],
          undefined
        >['content']['application/x-www-form-urlencoded']
  >
}) =>
  fetchAsJson<void>('/api/v1/heroku/sso/login', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/marketplace/aws/signup
// ts-unused-exports:disable-next-line
export const aWSSignup = async <
  T = operations['AWSSignup']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['AWSSignup']['requestBody'],
        undefined
      >['content']['application/x-www-form-urlencoded'],
>(args: {
  body: Exact<
    T,
    operations['AWSSignup']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['AWSSignup']['requestBody'],
          undefined
        >['content']['application/x-www-form-urlencoded']
  >
}) =>
  fetchAsJson<void>('/api/v1/marketplace/aws/signup', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/marketplace/aws/{organization_id}/_activate
// ts-unused-exports:disable-next-line
export const postAwsMarketplaceActivation = async (args: {
  pathParameters: operations['postAwsMarketplaceActivation']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/marketplace/aws/{organization_id}/_activate', args), {
    method: 'POST',
  })

// GET /api/v1/marketplace/aws/{organization_id}/contracts
// ts-unused-exports:disable-next-line
export const getAwsContractsV1 = async (args: {
  pathParameters: operations['getAwsContractsV1']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/marketplace/aws/{organization_id}/contracts', args), {
    method: 'GET',
  })

// POST /api/v1/marketplace/aws/{organization_id}/contracts/{contract}/overage
// ts-unused-exports:disable-next-line
export const sendAwsOverageV1 = async <
  T = operations['sendAwsOverageV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['sendAwsOverageV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['sendAwsOverageV1']['parameters']['path']
  body: Exact<
    T,
    operations['sendAwsOverageV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['sendAwsOverageV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/marketplace/aws/{organization_id}/contracts/{contract}/overage', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/marketplace/azure/private_offer
// ts-unused-exports:disable-next-line
export const handleAzurePrivateOfferV1 = async (args: {
  queryParameters: operations['handleAzurePrivateOfferV1']['parameters']['query']
}) =>
  fetchAsJson<{
    subscriptionId: string
  }>(applyParameters('/api/v1/marketplace/azure/private_offer', args), {
    method: 'POST',
  })

// POST /api/v1/marketplace/azure/private_offer/webhook
// ts-unused-exports:disable-next-line
export const handleAzurePrivateOfferWebhookV2 = async <
  T = operations['handleAzurePrivateOfferWebhookV2']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['handleAzurePrivateOfferWebhookV2']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['handleAzurePrivateOfferWebhookV2']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['handleAzurePrivateOfferWebhookV2']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v1/marketplace/azure/private_offer/webhook', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// POST /api/v1/marketplace/azure/webhook/
// ts-unused-exports:disable-next-line
export const azureWebhookV1 = async <
  T = operations['azureWebhookV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['azureWebhookV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['azureWebhookV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['azureWebhookV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v1/marketplace/azure/webhook/', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/marketplace/azure/{organization_id}/contracts
// ts-unused-exports:disable-next-line
export const getAzureContractsV1 = async (args: {
  pathParameters: operations['getAzureContractsV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/marketplace/azure/{organization_id}/contracts', args),
    {
      method: 'GET',
    },
  )

// PUT /api/v1/marketplace/azure/{organization_id}/contracts
// ts-unused-exports:disable-next-line
export const createAzureContractV1 = async <
  T = operations['createAzureContractV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createAzureContractV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['createAzureContractV1']['parameters']['path']
  body: Exact<
    T,
    operations['createAzureContractV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createAzureContractV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/marketplace/azure/{organization_id}/contracts', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/marketplace/azure/{organization_id}/contracts/{contract}/overage
// ts-unused-exports:disable-next-line
export const sendAzureOverageV1 = async <
  T = operations['sendAzureOverageV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['sendAzureOverageV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['sendAzureOverageV1']['parameters']['path']
  body: Exact<
    T,
    operations['sendAzureOverageV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['sendAzureOverageV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/marketplace/azure/{organization_id}/contracts/{contract}/overage',
      args,
    ),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/marketplace/azure/{organization_id}/subscription
// ts-unused-exports:disable-next-line
export const unsubscribeAzureSubscriptionV1 = async (args: {
  pathParameters: operations['unsubscribeAzureSubscriptionV1']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/marketplace/azure/{organization_id}/subscription', args),
    {
      method: 'DELETE',
    },
  )

// GET /api/v1/marketplace/azure/{organization_id}/subscription
// ts-unused-exports:disable-next-line
export const retrieveAzureAccountDetailsV1 = async (args: {
  pathParameters: operations['retrieveAzureAccountDetailsV1']['parameters']['path']
}) =>
  fetchAsJson<{
    beneficiary: {
      email_id: string
      object_id: string
      puid: string
      tenant_id: string
    }
    id: string
    name: string
    offer_id: string
    plan_id: string
    purchaser: {
      email_id: string
      object_id: string
      puid: string
      tenant_id: string
    }
    status: 'PendingFulfillmentStart' | 'Subscribed' | 'Suspended' | 'Unsubscribed'
    term: {
      end_date: string
      start_date: string
      term_unit: string
    }
  }>(applyParameters('/api/v1/marketplace/azure/{organization_id}/subscription', args), {
    method: 'GET',
  })

// POST /api/v1/marketplace/azure/{organization_id}/subscription
// ts-unused-exports:disable-next-line
export const reassignAzureSubscriptionV1 = async <
  T = operations['reassignAzureSubscriptionV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['reassignAzureSubscriptionV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['reassignAzureSubscriptionV1']['parameters']['path']
  body: Exact<
    T,
    operations['reassignAzureSubscriptionV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['reassignAzureSubscriptionV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/marketplace/azure/{organization_id}/subscription', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/marketplace/gcp/sso_redirect
// ts-unused-exports:disable-next-line
export const gcpSsoRedirect = async <
  T = operations['gcpSsoRedirect']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['gcpSsoRedirect']['requestBody'],
        undefined
      >['content']['application/x-www-form-urlencoded'],
>(args: {
  body: Exact<
    T,
    operations['gcpSsoRedirect']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['gcpSsoRedirect']['requestBody'],
          undefined
        >['content']['application/x-www-form-urlencoded']
  >
}) =>
  fetchAsJson<void>('/api/v1/marketplace/gcp/sso_redirect', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// PUT /api/v1/marketplace/gcp/{organization_id}/project
// ts-unused-exports:disable-next-line
export const reassignGcpUserToAnotherProjectV1 = async <
  T = operations['reassignGcpUserToAnotherProjectV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['reassignGcpUserToAnotherProjectV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['reassignGcpUserToAnotherProjectV1']['parameters']['path']
  body: Exact<
    T,
    operations['reassignGcpUserToAnotherProjectV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['reassignGcpUserToAnotherProjectV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/marketplace/gcp/{organization_id}/project', args), {
    method: 'PUT',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/prices
// ts-unused-exports:disable-next-line
export const listPricesV1 = async (args?: {
  queryParameters?: operations['listPricesV1']['parameters']['query']
}) =>
  fetchAsJson<Array<components['schemas']['Prices']>>(applyParameters('/api/v1/prices', args), {
    method: 'GET',
  })

// GET /api/v1/prices/adjustment
// ts-unused-exports:disable-next-line
export const getPricesAdjustmentV1 = async (args: {
  queryParameters: operations['getPricesAdjustmentV1']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['Adjustment']>(
    applyParameters('/api/v1/prices/adjustment', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/prices/base_prices
// ts-unused-exports:disable-next-line
export const getBasePricesV1 = async (args?: {
  queryParameters?: operations['getBasePricesV1']['parameters']['query']
}) =>
  fetchAsJson<Array<components['schemas']['Price']>>(
    applyParameters('/api/v1/prices/base_prices', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/prices/bulk
// ts-unused-exports:disable-next-line
export const getBulkPricesV1 = async <
  T = operations['getBulkPricesV1']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['getBulkPricesV1']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  queryParameters?: operations['getBulkPricesV1']['parameters']['query']
  body: Exact<
    T,
    operations['getBulkPricesV1']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['getBulkPricesV1']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<Array<components['schemas']['Prices']>>(
    applyParameters('/api/v1/prices/bulk', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/prices/dnt
// ts-unused-exports:disable-next-line
export const getDntPricesV1 = async (args?: {
  queryParameters?: operations['getDntPricesV1']['parameters']['query']
}) =>
  fetchAsJson<{
    enterprise: number
    gold: number
    platinum: number
    standard: number
  }>(applyParameters('/api/v1/prices/dnt', args), {
    method: 'GET',
  })

// GET /api/v1/prices/organization/{organization_id}/uplifts
// ts-unused-exports:disable-next-line
export const getPricesUpliftsV1 = async (args: {
  pathParameters: operations['getPricesUpliftsV1']['parameters']['path']
}) =>
  fetchAsJson<{
    enterprise: number
    gold: number
    platinum: number
    standard: number
  }>(applyParameters('/api/v1/prices/organization/{organization_id}/uplifts', args), {
    method: 'GET',
  })

// GET /api/v1/prices/search
// ts-unused-exports:disable-next-line
export const searchPricesV1 = async (args?: {
  queryParameters?: operations['searchPricesV1']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['PaginatedPrices']>(
    applyParameters('/api/v1/prices/search', args),
    {
      method: 'GET',
    },
  )

// POST /api/v2/billing/costs/run_service
// ts-unused-exports:disable-next-line
export const runCostsV2 = async (args: {
  queryParameters: operations['RunCostsV2']['parameters']['query']
}) =>
  fetchAsJson<{
    job_id: string
    message: string
  }>(applyParameters('/api/v2/billing/costs/run_service', args), {
    method: 'POST',
  })

// GET /api/v2/billing/organization/{organization_id}
// ts-unused-exports:disable-next-line
export const getBillingDetailsV2 = async (args: {
  pathParameters: operations['getBillingDetailsV2']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['OrganizationResponse']>(
    applyParameters('/api/v2/billing/organization/{organization_id}', args),
    {
      method: 'GET',
    },
  )

// GET /api/v2/billing/organizations
// ts-unused-exports:disable-next-line
export const getBillingDetailsByEntitlement = async (args: {
  queryParameters: operations['getBillingDetailsByEntitlement']['parameters']['query']
}) =>
  fetchAsJson<Array<components['schemas']['OrganizationResponse']>>(
    applyParameters('/api/v2/billing/organizations', args),
    {
      method: 'GET',
    },
  )

// GET /api/v2/billing/organizations/orgs_with_usage
// ts-unused-exports:disable-next-line
export const getOrgsWithUsage = async (args: {
  queryParameters: operations['getOrgsWithUsage']['parameters']['query']
}) =>
  fetchAsJson<{
    organizations: string[]
  }>(applyParameters('/api/v2/billing/organizations/orgs_with_usage', args), {
    method: 'GET',
  })

// GET /api/v2/billing/organizations/{organization_id}/charts
// ts-unused-exports:disable-next-line
export const getChartsV2 = async (args: {
  pathParameters: operations['getChartsV2']['parameters']['path']
  queryParameters: operations['getChartsV2']['parameters']['query']
}) =>
  fetchAsJson<{
    data: Array<{
      timestamp: number
      values: Array<{
        id: string
        name: string
        type: string
        value: number
      }>
    }>
  }>(applyParameters('/api/v2/billing/organizations/{organization_id}/charts', args), {
    method: 'GET',
  })

// GET /api/v2/billing/organizations/{organization_id}/costs/instances
// ts-unused-exports:disable-next-line
export const getCostsByInstancesV2 = async (args: {
  pathParameters: operations['getCostsByInstancesV2']['parameters']['path']
  queryParameters: operations['getCostsByInstancesV2']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['Instances']>(
    applyParameters('/api/v2/billing/organizations/{organization_id}/costs/instances', args),
    {
      method: 'GET',
    },
  )

// GET /api/v2/billing/organizations/{organization_id}/costs/instances/{instance_id}/items
// ts-unused-exports:disable-next-line
export const getItemizedCostsByInstanceV2 = async (args: {
  pathParameters: operations['getItemizedCostsByInstanceV2']['parameters']['path']
  queryParameters: operations['getItemizedCostsByInstanceV2']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['Items']>(
    applyParameters(
      '/api/v2/billing/organizations/{organization_id}/costs/instances/{instance_id}/items',
      args,
    ),
    {
      method: 'GET',
    },
  )

// GET /api/v2/billing/organizations/{organization_id}/costs/items
// ts-unused-exports:disable-next-line
export const getCostsByItemsV2 = async (args: {
  pathParameters: operations['getCostsByItemsV2']['parameters']['path']
  queryParameters: operations['getCostsByItemsV2']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['Items']>(
    applyParameters('/api/v2/billing/organizations/{organization_id}/costs/items', args),
    {
      method: 'GET',
    },
  )

// GET /api/v2/billing/organizations/{organization_id}/instances/{instance_id}/charts
// ts-unused-exports:disable-next-line
export const getChartsByInstanceV2 = async (args: {
  pathParameters: operations['getChartsByInstanceV2']['parameters']['path']
  queryParameters: operations['getChartsByInstanceV2']['parameters']['query']
}) =>
  fetchAsJson<{
    data: Array<{
      timestamp: number
      values: Array<{
        id: string
        name: string
        type: string
        value: number
      }>
    }>
  }>(
    applyParameters(
      '/api/v2/billing/organizations/{organization_id}/instances/{instance_id}/charts',
      args,
    ),
    {
      method: 'GET',
    },
  )

// POST /api/v2/marketplace/azure/webhook/
// ts-unused-exports:disable-next-line
export const azureWebhookV2 = async <
  T = operations['azureWebhookV2']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['azureWebhookV2']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['azureWebhookV2']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['azureWebhookV2']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>('/api/v2/marketplace/azure/webhook/', {
    method: 'POST',
    body: JSON.stringify(args.body),
  })
